<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :base-info="baseInfo"
    resource="billing_sku_rates" />
</template>

<script>
import BrandIcon from '@/sections/BrandIcon'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SKUSubcategoryDetail',
  mixins: [WindowsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        {
          field: 'sku_id',
          title: 'SKU_ID',
        },
        {
          field: 'sku',
          title: 'SKU',
        },
        {
          field: 'provider',
          title: this.$t('op_83'),
          slots: {
            default: ({ row }, h) => {
              const val = row.provider
              if (!val) return '-'
              if (val === '__all__') return this.$t('op_84')
              return [
                <BrandIcon name={ val } />,
              ]
            },
          },
        },
        {
          field: 'customer',
          title: this.$t('op_85'),
        },
        {
          field: 'customer_id',
          title: this.$t('op_88'),
          formatter: ({ cellValue }) => {
            if (cellValue === '__all__') return this.$t('op_84')
            return cellValue
          },
        },
        {
          field: 'cloudaccount',
          title: this.$t('op_46'),
        },
        {
          field: 'cloudaccount_id',
          title: this.$t('op_89'),
          formatter: ({ cellValue }) => {
            if (cellValue === '__all__') return this.$t('op_84')
            return cellValue
          },
        },
        {
          field: 'start_units',
          title: this.$t('op_86'),
        },
        {
          field: 'rate',
          title: this.$t('op_69'),
          formatter: ({ row, cellValue }) => {
            const value = row.rate_type === 'amount' ? cellValue : cellValue * 100
            const currencyZh = row.currency === 'USD' ? this.$t('op_68') : this.$t('op_67')
            const unit = row.unit ? `/${row.unit}` : ''
            return `${value}${row.rate_type === 'amount' ? currencyZh : '%'}${unit}`
          },
        },
        {
          field: 'rate_type',
          title: this.$t('op_87'),
          formatter: ({ cellValue }) => {
            const ret = {
              percent: this.$t('op_60'),
              amount: this.$t('op_61'),
            }
            return ret[cellValue]
          },
        },
      ],
    }
  },
}
</script>
